import { render } from "./JobSyncDashboard.vue?vue&type=template&id=90d71506&scoped=true"
import script from "./JobSyncDashboard.vue?vue&type=script&lang=js"
export * from "./JobSyncDashboard.vue?vue&type=script&lang=js"

import "./JobSyncDashboard.vue?vue&type=style&index=0&id=90d71506&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90d71506"]])

export default __exports__